import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { useTranslation } from '../context/TranslationContext';
import { isProfileSystemSelected, normalizeProfileSystemId } from '../lib/vmkProductSpec';

const ProfileSystemPicker = ({
  profileSystems,
  config,
  onConfigChange,
  translateName,
  translateDescription,
  title,
  description,
  normalizeProfileId,
  isProfileSelected,
}) => {
  const { t } = useTranslation();
  const labelFor = translateName || ((id, name) => name);
  const descriptionFor = translateDescription || ((id, description) => description);
  const resolveProfileId = normalizeProfileId || normalizeProfileSystemId;
  const isSelected = isProfileSelected || ((configId, optionId) =>
    isProfileSystemSelected(configId, optionId));

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">{title || t('options.profileSystem')}</CardTitle>
        <CardDescription className="text-xs">{description || t('options.selectManufacturer')}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-3">
          {profileSystems.map((system) => {
            const selected = isSelected(config.profileSystem, system.id);
            return (
              <button
                key={system.id}
                type="button"
                onClick={() => onConfigChange('profileSystem', resolveProfileId(system.id))}
                className={`p-4 rounded-lg border-2 transition-all hover:border-orange-400 hover:bg-orange-50 ${
                  selected ? 'border-orange-500 bg-orange-50 shadow-md' : 'border-gray-200 bg-white'
                }`}
              >
                <div className={`w-full h-20 mb-2 rounded flex items-center justify-center p-2 ${
                  selected ? 'bg-white' : 'bg-gray-50'
                }`}>
                  <img
                    src={system.logo}
                    alt={system.name}
                    className="max-h-full max-w-full object-contain"
                    style={{
                      display: 'block',
                      width: 'auto',
                      height: 'auto',
                      maxWidth: '100%',
                      maxHeight: '100%',
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const fallback = e.target.nextElementSibling;
                      if (fallback) {
                        fallback.style.display = 'flex';
                        fallback.style.alignItems = 'center';
                        fallback.style.justifyContent = 'center';
                      }
                    }}
                  />
                  <div className="hidden text-xl font-bold" style={{ color: system.color || '#666' }}>
                    {labelFor(system.id, system.name)}
                  </div>
                </div>
                <div className="text-xs font-semibold text-gray-900 text-center">
                  {labelFor(system.id, system.name)}
                </div>
                {system.description && (
                  <div className="text-[10px] text-gray-500 text-center mt-0.5">
                    {descriptionFor(system.id, system.description)}
                  </div>
                )}
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileSystemPicker;
